export default "__VITE_ASSET__B6YbcCsq__"